module.exports = __webpack_public_path__ + "img/financial_strain_icon.331038a8.svg";